(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('SendProposalTelesaqueController', sendProposalTelesaqueController)

  sendProposalTelesaqueController.inject = ['NotificationService', 'SendProposalTelesaqueService', 'MessagesPortalService', 'LangService', '$timeout', 'FoundationApi']

  function sendProposalTelesaqueController (NotificationService, SendProposalTelesaqueService, MessagesPortalService, LangService, $timeout, FoundationApi) {
    var vm = this;
    vm.sendMessage = sendMessage;
    vm.stoneageValidation = stoneageValidation;
    vm.getCetelenProposalInfo = getCetelenProposalInfo;
    vm.checkHasOpenCardBlur = checkHasOpenCardBlur;
    vm.fields = {};
    vm.showLastFourDigits = false;
    vm.hsmTemplateReplaced = '';
    vm.proposalInfo = {};
    vm.telesaqueAllowance = {};
    vm.templateData = {};
    vm.isValidCpf = false;

    LangService
      .getPageLabels({ 'page': 'menu.messagesPortal.sendProposalTelesaque' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    searchMessage();
    getTelesaqueAllowance();

    function searchMessage () {
      SendProposalTelesaqueService
        .getMessageTelesaque()
        .$promise
        .then(function (data) {
          if (data) {
            vm.templateData = data;
            vm.messagesTemplate = data.template;
            vm.hsmTemplateReplaced = vm.messagesTemplate['hsm_message']['template'];
            vm.hsmTemplateReplacedFront = vm.hsmTemplateReplaced;
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.errorLoadingTemplates);
        });
    }

    function getTelesaqueAllowance () {
      SendProposalTelesaqueService
        .getTelesaqueAllowance()
        .$promise
        .then(function (data) {
          if (data) {
            vm.telesaqueAllowance = data;
            vm.showLastFourDigits = !vm.telesaqueAllowance.validationStoneage;
          }
        })
    }

    function stoneageValidation () {
      if (!vm.fields.phone || !vm.fields.cpf) {
        return false;
      }

      if (!vm.telesaqueAllowance.validationStoneage) {
        getCetelenProposalInfo();
        return false;
      }
      
      SendProposalTelesaqueService.stoneageValidation({
          phone: vm.fields.phone,
          cpf: vm.fields.cpf
        }).$promise
        .then(function (validationStoneage) {

        vm.showLastFourDigits = false;

        if (!validationStoneage.success) {
          NotificationService.errorHandler('', vm.labels.stoneageValidationError);
          return false;
        }

        if (validationStoneage.response.status == 'NOT_APPROVED') {
          NotificationService.errorHandler('', validationStoneage.response.descricao);
          return false;
        }

        vm.showLastFourDigits = true;
        vm.isValidCpf = true;
        getCetelenProposalInfo();
      }).catch(function (error) {
        NotificationService.errorHandler('', error.data.message);
        if (error.status == 400) {
          vm.showLastFourDigits = false;
          vm.fields.lastFourDigits = '';
          vm.proposalInfo = {};
          vm.isValidCpf = false;
        }
        console.error(error);
      })
    }

    function getCetelenProposalInfo () {
      if (!vm.fields.phone || !vm.fields.cpf || !vm.fields.lastFourDigits || !vm.proposalInfo) {
        return false;
      }
      try {
        SendProposalTelesaqueService.getCetelenProposalInfo({
          phone: vm.fields.phone,
          cpf: vm.fields.cpf,
          lastFourDigits: vm.fields.lastFourDigits
        })
        .$promise
        .then(function (data) {
          vm.proposalInfo = data;
          var message = vm.hsmTemplateReplaced;
          message = message.replace('{{1}}', data.name);
          message = message.replace('{{2}}', data.lastFourDigitCardNumber);
          message = message.replace('{{3}}', data.valueOfInstallmentWithdraw);
          vm.hsmTemplateReplacedFront = message;
          vm.isValidCpf = true;
        }).catch(function (error) {
          NotificationService.errorHandler('', error.data.message);
          vm.isValidCpf = false;
          console.log(error);
        });
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.getCetelenProposalInfoError);
        console.log(error);
      }
    }

    function makePayloadMessage () {
      return {
        hsmParams: {
          "{{1}}" : vm.proposalInfo.name,
          "{{2}}" : vm.proposalInfo.lastFourDigitCardNumber,
          "{{3}}" : vm.proposalInfo.valueOfInstallmentWithdraw
        },
        messageTemplateId: vm.messagesTemplate['_id'],
        message: vm.messagesTemplate.message,
        template: vm.messagesTemplate,
        phone: vm.fields.phone,
        cpf: vm.fields.cpf
      }
    }

    async function validateFields (checkHasOpenCardFlag = true) {
      if (vm.fields.phone === undefined || vm.fields.phone === '') {
        NotificationService.warningHandler('', vm.labels.requiredPhone)
        return false
      }
      if (vm.fields.cpf === undefined || vm.fields.cpf === '') {
        NotificationService.warningHandler('', vm.labels.requiredCpf)
        return false
      }
      if (!vm.isValidCpf) {
        NotificationService.warningHandler('', vm.labels.invalidCpf)
        return false
      }
      if (vm.fields.lastFourDigits === undefined || vm.fields.lastFourDigits === '') {
        NotificationService.warningHandler('', vm.labels.lastFourDigits)
        return false
      }
      if (checkHasOpenCardFlag) {
        const hasOpenCard = await checkHasOpenCard();
        if (hasOpenCard) {
          FoundationApi.publish('confirmSendMessageModal', 'open');
          return false;
        }
      }
      return true;
    }

    async function sendMessage (checkHasOpenCardFlag = true) {
      if (await validateFields(checkHasOpenCardFlag)) {
        MessagesPortalService
          .sendMessage(makePayloadMessage())
          .$promise
          .then(function (data) {
            if (data.success) {
              NotificationService.successHandler(data, data.message);
              resetVariables();
            } else if (data.warning) {
              NotificationService.warningHandler(data, data.message);
            } else {
              NotificationService.errorHandler(data, data.message);
            }
        }).catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.errorSendMessage)
        })
      } else {
        NotificationService.errorHandler(data, vm.labels.errorSendMessage)
      }
    }

    async function checkHasOpenCard () {
      try {
        const validation = await MessagesPortalService.checkHasOpenCard({
          phone: vm.fields.phone,
          template: vm.messagesTemplate
        }).$promise

        return validation.hasOpenCard || false
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
      }
    }

    async function checkHasOpenCardBlur () {
      try {
        if (!vm.fields.phone || !vm.messagesTemplate) {
          return false
        }
        const validation = await MessagesPortalService.checkHasOpenCard({
          phone: vm.fields.phone,
          template: vm.messagesTemplate
        }).$promise

        if (validation.hasOpenCard) {
          NotificationService.warningHandler('', vm.labels.hasOpenCard)
        }
        stoneageValidation();
      } catch (error) {
        NotificationService.errorHandler('', vm.labels.cpfValidationError)
      }
    }

    function resetVariables () {
      vm.fields = {};
      vm.hsmTemplateReplacedFront = vm.hsmTemplateReplaced;
      vm.proposalInfo = {};
      vm.isValidCpf = false;
      if (vm.telesaqueAllowance.validationStoneage) {
        vm.showLastFourDigits = false;
      }
    }
  }
})();
